import { render, staticRenderFns } from "./index.vue?vue&type=template&id=368ff94c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=368ff94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_3wbwi6es6qkhix4tqpj2wcthvi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368ff94c",
  null
  
)

export default component.exports